<template>
  <div id="listagem-solicitacao">
    <div v-if="listaInterna.length || listaExterna.length">
      <div
        v-for="(contrato, index) in contratosMap"
        :key="index"
        style="margin-bottom: 20px;"
      >
        <div
          style="padding: 15px 0;"
        >
          <h3
            style="font: normal normal 600 16px/22px Open Sans; letter-spacing: 0; color: #333333;"
          >
            {{ contrato.plano }}
          </h3>
          <span
            class="sub"
            style="font: normal normal normal 11px/15px Open Sans; letter-spacing: 0; color: #555555;"
          >
            {{ textoVinculoContrato }}: {{ contrato.numeroContrato }}
          </span>
        </div>

        <div
          v-for="(card, index) of contrato.data.slice(0, quantidadeItens)"
          :key="index"
          style="margin-top: 5px; cursor:pointer;"
        >
          <div
            v-if="card.cardExterno"
          >
            <slot
              name="externo"
              :card="card"
            />
          </div>

          <div
            v-else
          >
            <slot
              name="interno"
              :card="card"
            />
          </div>
        </div>

        <div
          v-if="contrato.data.length === 0"
          style="background: #F6F6F6 0 0 no-repeat padding-box; border-radius: 6px; padding: 18px;"
        >
          <div
            style="font: normal normal normal 14px/16px SF Pro Text; letter-spacing: 0; color: #000000; opacity: 0.5;"
          >
            Não há registros para este {{ textoVinculoContrato.toLowerCase() }}.
          </div>
        </div>
        <el-button
          v-if="contrato.data.length > 0"
          class="btn-historico"
          @click="goToHistorico(contrato)"
        >
          Ver histórico <i class="el-icon-arrow-right"/>
        </el-button>
      </div>
    </div>
    <ErrorVazio
      style="margin-top: 100px;"
      v-if="!listaExterna.length && !listaInterna.length"
      :btn-texto="btnText"
      :show-btn="permiteNovo"
      @click="novaSolicitacao"
    />
    <DialogoConclusaoSolicitacao
      v-model="mostrarSucesso"
      :protocolo-sucesso="protocoloSucesso"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapSectionListByContrato } from '@/components/TemplateSolicitacao/TemplateSolicitacaoHelpers'
import DialogoConclusaoSolicitacao from '@/components/TemplateSolicitacao/componentes/DialogoConclusaoSolicitacao'
import ErrorVazio from '@/components/Error/ErrorVazio'
export default {
  name: 'ComponenteSolicitacaoListagem',
  data () {
    return {
      myData: '',
      mostrarSucesso: false,
      protocoloSucesso: null
    }
  },
  components: {
    ErrorVazio,
    DialogoConclusaoSolicitacao
  },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    listaInterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    },
    rotaHistorico: {
      type: String,
      default: ''
    },
    rotaNovo: {
      type: String,
      default: ''
    },
    quantidadeItens: {
      type: Number,
      default: 3
    },
    permiteNovo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['user', 'contratos']),
    lista () {
      if (Array.isArray(this.listaExterna) && this.listaExterna.length > 0) {
        const mesclador = {}

        this.listaInterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          mesclador[numeroContrato] = item
        })

        this.listaExterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          const itemElement = item[this.chaveExterna]

          if (!mesclador[numeroContrato]) {
            mesclador[numeroContrato] = {
              numeroContrato: numeroContrato,
              ocorrencias: itemElement
            }
          } else {
            mesclador[numeroContrato].ocorrencias = mesclador[numeroContrato].ocorrencias.concat(itemElement)

            mesclador[numeroContrato].ocorrencias.sort((a, b) => {
              try {
                return Number.parseInt(b.data_registro) - Number.parseInt(a.data_registro)
              } catch (e) {
                return -1
              }
            })
          }
        })

        const listaMesclada = []

        Object.keys(mesclador).forEach((key) => {
          listaMesclada.push(mesclador[key])
        })

        return listaMesclada
      }

      return this.listaInterna
    },
    btnText () {
      return 'Nova Solicitação'
    },
    collapseds () {
      return [...Array(this.contratos.length).keys()]
    },
    contratosMap () {
      const lista = mapSectionListByContrato(this.contratos, this.lista)
      if (!this.aplicacao.visualizaContratosVazios) {
        return lista.filter((i) => i.data.length > 0)
      }
      return lista
    }
  },
  methods: {
    goToHistorico (contrato) {
      return this.$router.push({
        path: this.rotaHistorico,
        query: {
          numeroContrato: contrato.numeroContrato || 'n/a'
        }
      })
    },
    novaSolicitacao () {
      return this.$router.push({
        path: this.rotaNovo
      })
    }
  }
}
</script>

<style lang="less">
.el-button {
  &.btn-historico {
    margin-top: 5px;
    text-transform: none;
    color: #006FB9;
    border-color: #006FB9;
    font-size: 12px;
    height: 30px;
    border-radius: 15px;
    padding-left: 15px;
    padding-right: 10px;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
